import React from 'react'

interface FormRowProps {
  label: string
  children: React.ReactNode
  labelWidth?: string
  labelClassName?: string
}

export const FormRow: React.FC<FormRowProps> = ({ 
  label, 
  children, 
  labelWidth = 'w-[155px] min-w-[155px]',
  labelClassName = ''
}) => (
  <div className="flex flex-col gap-4 min-[1600px]:flex-row min-[1600px]:items-center">
    <label className={`${labelWidth} text-white text-[20px] font-proxima-semibold leading-none ${labelClassName}`}>
      {label}
    </label>
    <div className="flex items-center flex-1">{children}</div>
  </div>
)